import { Typography } from 'antd'
import { type ParagraphProps as AntdParagraphProps } from 'antd/lib/typography/Paragraph'
import { forwardRef } from 'react'
import styles from './styles.module.scss'

export interface ParagraphProps extends AntdParagraphProps {
  noMargin?: boolean
}

export const Paragraph = forwardRef<HTMLDivElement, ParagraphProps>(
  ({ noMargin, ...props }, ref) => {
    const classNames = noMargin ? [props.className, styles.noMargin] : [props.className]

    return <Typography.Paragraph {...props} className={classNames.join(' ')} ref={ref} />
  },
)
